/* eslint-disable no-nested-ternary */

import { AuditEvent } from '@brands/services/audit_trails/listAuditTrails';

export type SortKeys = keyof AuditEvent;
export type SortOrder = 'asc' | 'desc';
export type Comparator<T> = (a: T, b: T) => number;

export const sortedDataFn = (auditTrailList: AuditEvent[], sortKey: SortKeys): AuditEvent[] => {
  return auditTrailList?.sort((a, b) => {
    return a[sortKey]! > b[sortKey]! ? 1 : -1;
  });
};

export const sortData = <T extends Record<string, any>>({
  tableData,
  sortKey,
  reverse,
}: {
  tableData: T[];
  sortKey: SortKeys;
  reverse: boolean;
}): T[] => {
  const sortedData = [...tableData].sort((a, b) => {
    let aValue;
    let bValue;
    switch (sortKey) {
      case 'user':
        aValue = `${a?.user?.full_name} (${a?.user?.role.name})` || '';
        bValue = `${b?.user?.full_name} (${b?.user?.role.name})` || '';
        break;
      case 'actor':
        aValue = `${a?.actor?.full_name} (${a?.actor?.role.name})` || '';
        bValue = `${b?.actor?.full_name} (${b?.actor?.role.name})` || '';
        break;
      case 'action_message':
        aValue = a?.action_message || '';
        bValue = b?.action_message || '';
        break;
      case 'created_at':
        aValue = a.created_at ? new Date(a.created_at).getTime() : null;
        bValue = b.created_at ? new Date(b.created_at).getTime() : null;
        break;
      default:
        aValue = '';
        bValue = '';
    }
    if (aValue < bValue) {
      return reverse ? 1 : -1;
    }
    if (aValue > bValue) {
      return reverse ? -1 : 1;
    }
    return 0;
  });
  return sortedData;
};
